import { isSameDay } from 'date-fns';
import { RefObject, useCallback } from 'react';

import { isDateWithinDatePickerBounds } from './isDateWithinDatePickerBounds';
import { parseDatePickerInputValue } from './parseDatePickerInputValue';

type TOptions = {
  wrapperRef: RefObject<HTMLElement | null>;
  dateFormat: string;
  minDate: Date;
  maxDate: Date;
  selected: Date | null;
  onCommit: (date: Date | null) => void;
};

export const useDatePickerTypedInputCommit = ({
  wrapperRef,
  dateFormat,
  minDate,
  maxDate,
  selected,
  onCommit,
}: TOptions) =>
  useCallback(() => {
    const input = wrapperRef.current?.querySelector('input');
    if (!(input instanceof HTMLInputElement)) {
      return;
    }

    const raw = input.value.trim();
    if (!raw) {
      if (selected !== null) {
        onCommit(null);
      }
      return;
    }

    const parsed = parseDatePickerInputValue(raw, dateFormat);
    if (!parsed || !isDateWithinDatePickerBounds(parsed, minDate, maxDate)) {
      return;
    }

    if (selected === null || !isSameDay(selected, parsed)) {
      onCommit(parsed);
    }
  }, [dateFormat, maxDate, minDate, onCommit, selected, wrapperRef]);
